export default "__VITE_ASSET__a9b9d1a9__"